






































































import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { OrganisationService } from '@/services/OrganisationService';
import {
  OrganisationModel,
  OrganisationSearchModel,
  RouteRegEx,
  StickySettingsActions,
  StickyStoreNames,
  StickySettingsGetters,
  StickySettingsFields
} from '@/types';
import MStoreTable from '@/components/shared/Table/MStoreTable.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { ComponentHelper, MTablehelper, RouteHelpers } from '@/mixins';

export default Vue.extend({
  name: 'OrganisationManagement',
  mixins: [ComponentHelper, MTablehelper, RouteHelpers],
  data() {
    return {
      isLoading: false,
      pageIsLoading: true,
      organisations: [] as OrganisationModel[],
      organisationSearchModel: {} as OrganisationSearchModel,
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'defaultRole.name',
          label: 'Default Role',
          sortable: true
        },
        {
          key: 'actions',
          label: '',
          sortable: false
        }
      ]
    };
  },
  methods: {
    ...mapActions(StickyStoreNames.OrganisationManagement, [
      StickySettingsActions.ResetStickyState,
      StickySettingsActions.SetStickyStateField
    ]),
    async initialise(this: any) {
      try {
        this.pageIsLoading = true;
        await OrganisationService.checkMaintenancePermissions();
        this.resetFilters();
        await this.getOrganisationsAsync();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.pageIsLoading = false;
      }
    },
    async getOrganisationsAsync(this: any) {
      try {
        this.isLoading = true;
        this.organisations = await OrganisationService.getOrganisationsAsync(this.organisationSearchModel);
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
    resetFilters(this: any) {
      const canKeepState = this.canKeepState(RouteRegEx.Organisation);
      if (!canKeepState) {
        this.resetStickyState();
        this.resetMTableState();
      }
      this.organisationSearchModel = {
        isDeactivated: this.organisationManagementStateField(StickySettingsFields.ShowDeactivated) ? null : false
      };
    },
    navigateToId(this: any, routeName: any, data: any = null, paramName: string = 'id') {
      if (data) {
        const value = paramName === 'id' ? data : data.id;
        this.onTableStateFieldUpdated('selectedPk', value);
      }
      this.navigateToRoute(routeName, data, paramName);
    }
  },
  computed: {
    ...mapGetters(StickyStoreNames.OrganisationManagement, [StickySettingsGetters.GetStickyStateField]),
    organisationManagementStateField(this: any) {
      return (field: string) => this.getStickyStateField(field);
    },
    localshowDeactivated: {
      get(this: any): boolean {
        return this.organisationManagementStateField(StickySettingsFields.ShowDeactivated);
      },
      set(this: any, value: any) {
        this.setStickyStateField({
          field: StickySettingsFields.ShowDeactivated,
          value
        });
        this.organisationSearchModel.isDeactivated = value ? null : false;
      }
    }
  },
  watch: {
    organisationSearchModel: {
      handler(val, oldVal) {
        this.getOrganisationsAsync();
      },
      deep: true
    }
  },
  mounted() {
    this.initialise();
  },
  components: {
    MStoreTable,
    LoadingSpinner
  }
});
